/**
 * RESPONSIBILITY: draw the church's own story.
 */
import { Html } from '@framework/react';
import type { AboutStorySection } from '@app/sections';
import { Picture } from '../commons/Picture';

export function AboutStory({ c }: { c: AboutStorySection }) {
  return (
    <section className="band band-tint">
      <div className="wrap split">
        <div className="stack">
          <h2>{c.heading}</h2>
          {c.bodyHtml && <Html className="md-body lede">{c.bodyHtml}</Html>}
          {c.ctaLabel && <a className="btn" href={c.ctaHref || '#'}>{c.ctaLabel}</a>}
        </div>
        <Picture value={c.image} alt="" className="block-pic" />
      </div>
    </section>
  );
}
